import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import Input from "../components/ui/Input";
import { createShipment } from '../api';
import axios from 'axios';
import { Autocomplete, TextField } from '@mui/material'; // Import Autocomplete and TextField from MUI

const Modal = ({ isOpen, onClose, newShipment, setNewShipment, onSave }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/cuentas`);
        // Sort accounts alphabetically by nombre_cuenta
        const sortedAccounts = response.data.sort((a, b) => 
          a.nombre_cuenta.localeCompare(b.nombre_cuenta)
        );
        setAccounts(sortedAccounts);
      } catch (error) {
        console.error('Error fetching accounts:', error);
      }
    };

    fetchAccounts();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewShipment((prevState) => ({ ...prevState, [name]: value }));
    // Clear error when user types
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  // New handler for Autocomplete selection
  const handleVendorChange = (event, newValue) => {
    setNewShipment((prevState) => ({ 
      ...prevState, 
      vendor: newValue ? newValue.nombre_cuenta : '' 
    }));
    // Clear error when user selects
    if (errors.vendor) {
      setErrors(prev => ({ ...prev, vendor: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newShipment.Truck || newShipment.Truck.trim() === '') {
      newErrors.Truck = 'El número de embarque es requerido';
    }
    if (!newShipment.vendor || newShipment.vendor.trim() === '') {
      newErrors.vendor = 'El cliente es requerido';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (isSaving) return;
    
    if (!validateForm()) {
      return; // Stop if validation fails
    }
    
    setIsSaving(true);

    try {
      await createShipment(newShipment);
      onSave();
    } catch (error) {
      alert('Error al guardar el embarque.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isSaving) {
      handleSave();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-96 p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Nuevo Embarque</h2>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="Truck" className="block text-sky-800 font-medium mb-1">
              Truck
            </label>
            <Input
              id="Truck"
              name="Truck"
              value={newShipment?.Truck || ''}
              onChange={handleInputChange}
              placeholder="Número de embarque"
              className={errors.Truck ? "border-red-500" : ""}
            />
            {errors.Truck && (
              <p className="text-red-500 text-sm mt-1">{errors.Truck}</p>
            )}
          </div>

          <div>
            <label htmlFor="vendor" className="block text-sky-800 font-medium mb-1">
              Cliente
            </label>
            <Autocomplete
              id="vendor"
              options={accounts}
              getOptionLabel={(option) => option.nombre_cuenta || ''}
              value={accounts.find(account => account.nombre_cuenta === newShipment?.vendor) || null}
              onChange={handleVendorChange}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  placeholder="Seleccione un cliente"
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={!!errors.vendor}
                  helperText={errors.vendor}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '0.375rem',
                      backgroundColor: 'white',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: errors.vendor ? 'rgb(239, 68, 68)' : 'rgb(156, 163, 175)',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: errors.vendor ? 'rgb(239, 68, 68)' : 'rgb(59, 130, 246)',
                        borderWidth: '2px',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: errors.vendor ? 'rgb(239, 68, 68)' : 'inherit',
                      },
                    }
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              className="w-full"
            />
          </div>
        </form>

        <div className="mt-6 flex justify-end space-x-4">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={handleSave}>
            Guardar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Modal;